/*
  PA - HEDIYE BAREMLERI (15 Eyl 2026, v3.5)

  Sepette kademeli odul sistemi (kademeler shop.metafields.custom.hediye_baremleri):
    2.000 TL -> ucretsiz kargo (urun yok, Shopify kargo kurali hallediyor)
    3.000 TL -> P.A Logo Cap    (renk secilebilir)
    4.500 TL -> Lifting Essentials Sweatshirt - erkek (beden secilebilir)

  TASARIM KARARI - odulun 0 TL olmasi TEMANIN ISI DEGIL.
  Bu dosya sadece DOGRU SATIRI DOGRU PROPERTY ile sepete koyar:
    _hediye        = "1"
    _hediye_barem  = kademe id'si ("sapka" / "sweat")
    _hediye_esik   = kurus cinsinden esik (fonksiyon dogrulamasi icin)
  Fiyati sifirlayan taraf Paket Motoru fonksiyonudur. Fonksiyon yayina
  alinmadan once bu satirlar sepette TAM FIYATTAN gorunur - dev temasinda
  beklenen davranis budur, hata degil.

  BAREM TABANI: indirim SONRASI odenecek tutar (cart.total_price), hediye
  satirlarinin kendi tutari dusulerek. Ucretsiz kargo esigini Shopify de
  indirim sonrasi tutara gore olcuyor; bar ile kasa boylece ayni dili konusur.

  v3 - TEKLEME VE HIZ:
  - Hediye satirinin gorunumu (rozet, secici, gizli adet/kaldir, fiyat) artik
    SUNUCUDA basiliyor: snippets/pa-hediye-satir.liquid + quick-cart / main-cart
    icindeki kucuk kosullar. Burasi ayni sinif/attribute'lari bulunca dokunmaz;
    yalnizca JS'siz kalan durumlar icin yedek olarak susler.
  - Temanin /cart/change|update|add|clear.js cagrilari fetch uzerinden
    yakalanir; cevaptaki sepetle HEMEN uzlastirilir. Onceden: DOM degisikligi
    beklenir (tema section fetch'i) + 280 ms debounce + /cart.js turu. Simdi o
    zincir yok. Kendi isteklerimiz X-PA-Hediye basligi tasir, dinlenmez.
  - Silme/adet degisikligi cevabi zaten sepet oldugu icin ekstra /cart.js yok.
  - Zincirdeki son istek "sections" ister (paketli bolum cizimi): sepet DOM'u
    ayni cevaptan cizilir; ayri section fetch'i ve apps olayi gerekmez.
    Sunucu tabani: her sepet degisikligi ~550-650 ms (indirim fonksiyonu her
    seferinde calisir) ve iki degisiklik zorunlu (musterininki + hediye).
    Bu yuzden alt sinir ~1,2-1,4 sn; daha asagisi ancak iyimser cizimle olur.

  v2 - SEPET YENILEME (yenile()): drawer icin temanin resmi kancasi
  apps:product-added-to-cart (quick-cart section'i sunucudan komple yeniden
  alinir), sepet sayfasi icin sepette hala var olan hediye disi bir satirin
  adet kutusuna change olayi.

  DONGU NOTU: uzlastirma idempotent - yapilacak is kalmayinca hicbir istek
  atmaz. Tema sepeti yeniden cizdiginde observer tekrar tetiklenir, ikinci
  turda is cikmaz ve durur.
*/
(function () {
  var el = document.getElementById('pa-hediye-config');
  if (!el) return;

  var CFG;
  try { CFG = JSON.parse(el.textContent); } catch (e) { return; }
  if (!CFG || !CFG.acik) return;

  var KADEMELER = CFG.kademeler || [];
  if (!KADEMELER.length) return;

  var ITEM_SEL = '.quick-cart__item[data-key], .cart__form-item[data-key]';
  var BEDENLER = ['XS', 'S', 'M', 'L', 'XL', 'XXL', '2XL', '3XL'];
  var BASLIK = { 'Content-Type': 'application/json', Accept: 'application/json', 'X-PA-Hediye': '1' };

  var mesgul = false;
  var zaman = null;
  var sonTutarlilik = 0;
  /* Iyimser cizim durumu: sunucu cevabi beklenirken ekranda gosterilecek
     ekleme(ler) ve gizlenecek satir anahtarlari. Sunucudan gercek cizim
     gelince sifirlanir. */
  var iyimser = null;

  /* ---------- yardimcilar ---------- */

  function para(k) {
    return (k / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ₺';
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
  }
  function sepetAl() {
    return fetch('/cart.js', { headers: { Accept: 'application/json', 'X-PA-Hediye': '1' } }).then(function (r) { return r.json(); });
  }
  function hafizaOku(id) {
    try { return parseInt(localStorage.getItem('pa_hediye_' + id), 10) || 0; } catch (e) { return 0; }
  }
  function hafizaYaz(id, vid) {
    try { localStorage.setItem('pa_hediye_' + id, String(vid)); } catch (e) {}
  }
  function sepetSayfasi() {
    return location.pathname.indexOf('/cart') === 0;
  }
  function sepetMi(c) {
    return !!(c && c.token && typeof c.total_price === 'number' && c.items);
  }

  /* Hediye satirlari barem tabanina SAYILMAZ; fonksiyon yayina girmeden once
     tam fiyatli durduklari icin dusulmezse esik kendi kendini besler. */
  function uygunTutar(c) {
    var t = c.total_price || 0;
    (c.items || []).forEach(function (i) {
      if (i.properties && i.properties._hediye) t -= i.final_line_price;
    });
    return t < 0 ? 0 : t;
  }

  function hediyeSatirlari(c) {
    var m = {};
    (c.items || []).forEach(function (i) {
      var p = i.properties || {};
      if (!p._hediye) return;
      var b = p._hediye_barem || '';
      if (!m[b]) m[b] = [];
      m[b].push(i);
    });
    return m;
  }

  function stoktakiler(k) {
    return (k.secenekler || []).filter(function (s) { return s.stok; });
  }
  function secenekBul(k, vid) {
    var l = k.secenekler || [];
    for (var i = 0; i < l.length; i++) if (l[i].id === vid) return l[i];
    return null;
  }

  /* Sepetteki diger urunlerin bedeninden tahmin: en sik gecen beden,
     o beden hediyede stokta degilse en yakin buyuk beden. */
  function bedenTahmini(cart, k) {
    var sayac = {};
    (cart.items || []).forEach(function (i) {
      if (i.properties && i.properties._hediye) return;
      var t = String(i.variant_title || i.title || '');
      var parcalar = t.split('/');
      for (var j = 0; j < parcalar.length; j++) {
        var v = parcalar[j].trim().toUpperCase();
        if (BEDENLER.indexOf(v) !== -1) sayac[v] = (sayac[v] || 0) + (i.quantity || 1);
      }
    });
    var enSik = null, enCok = 0;
    Object.keys(sayac).forEach(function (b) { if (sayac[b] > enCok) { enCok = sayac[b]; enSik = b; } });
    if (!enSik) return null;

    var stokta = stoktakiler(k);
    var tam = stokta.filter(function (s) { return String(s.ad).toUpperCase() === enSik; })[0];
    if (tam) return tam;

    var hedef = BEDENLER.indexOf(enSik);
    var siraliStok = stokta.slice().sort(function (a, b) {
      return BEDENLER.indexOf(String(a.ad).toUpperCase()) - BEDENLER.indexOf(String(b.ad).toUpperCase());
    });
    for (var q = 0; q < siraliStok.length; q++) {
      if (BEDENLER.indexOf(String(siraliStok[q].ad).toUpperCase()) >= hedef) return siraliStok[q];
    }
    return null;
  }

  /* Secim onceligi: musterinin onceki secimi > sepetten beden tahmini >
     kademenin varsayilani > stoktaki ilk secenek. */
  function varsayilanSecenek(k, cart) {
    var stokta = stoktakiler(k);
    if (!stokta.length) return null;

    var hatirlanan = secenekBul(k, hafizaOku(k.id));
    if (hatirlanan && hatirlanan.stok) return hatirlanan;

    if (k.bedenden_tahmin) {
      var tahmin = bedenTahmini(cart, k);
      if (tahmin) return tahmin;
    }
    var vars = secenekBul(k, k.varsayilan);
    if (vars && vars.stok) return vars;
    return stokta[0];
  }

  /* ---------- uzlastirma ---------- */

  function islemleriHesapla(cart) {
    var uygun = uygunTutar(cart);
    var mevcut = hediyeSatirlari(cart);
    var ops = [];
    var bilinen = {};

    KADEMELER.forEach(function (k) {
      if (k.tip !== 'hediye') return;
      bilinen[k.id] = 1;
      var satirlar = mevcut[k.id] || [];

      if (uygun < k.esik) {
        satirlar.forEach(function (i) { ops.push({ tip: 'sil', key: i.key }); });
        return;
      }
      if (!satirlar.length) {
        var s = varsayilanSecenek(k, cart);
        if (s) ops.push({ tip: 'ekle', vid: s.id, barem: k.id, esik: k.esik });
        return;
      }
      /* Ayni barem icin birden fazla satir olusmussa ilki kalir. */
      satirlar.slice(1).forEach(function (i) { ops.push({ tip: 'sil', key: i.key }); });
      if (satirlar[0].quantity > 1) ops.push({ tip: 'adet', key: satirlar[0].key, adet: 1 });
    });

    /* Kaldirilmis/yeniden adlandirilmis kademelerin satirlari temizlenir. */
    Object.keys(mevcut).forEach(function (b) {
      if (bilinen[b]) return;
      mevcut[b].forEach(function (i) { ops.push({ tip: 'sil', key: i.key }); });
    });

    return ops;
  }

  /* PAKETLI BOLUM CIZIMI (Shopify "bundled section rendering"):
     add.js / change.js istegine sections=<id,id> eklenince cevap, sepetin
     GUNCEL haliyle basilmis section HTML'ini de tasir. Boylece hediye
     eklendikten/silindikten sonra ayri bir section fetch'i (250 ms + kuyruk)
     ve ayri bir /cart.js turu gerekmez: tek istek, tek cizim. Yalnizca
     zincirdeki SON istek bolum ister (her istekte render maliyeti odenmez). */
  function bolumIdleri() {
    var ids = [];
    var qc = document.querySelector('.quick-cart[data-section-id]');
    if (qc) ids.push(qc.getAttribute('data-section-id'));
    var mc = document.querySelector('[data-section-type="cart"][data-section-id]');
    if (mc) ids.push(mc.getAttribute('data-section-id'));
    return ids;
  }

  /* Sonuc: istegin JSON cevabi. change.js -> sepetin kendisi (+sections);
     add.js -> eklenen satirlar (+sections). */
  function opUygula(op, bolumler) {
    var govde;
    var url;
    if (op.tip === 'ekle') {
      var props = { _hediye: '1', _hediye_barem: op.barem, _hediye_esik: String(op.esik) };
      url = '/cart/add.js';
      govde = { items: [{ id: op.vid, quantity: 1, properties: props }] };
    } else {
      url = '/cart/change.js';
      govde = { id: op.key, quantity: op.tip === 'sil' ? 0 : op.adet };
    }
    if (bolumler && bolumler.length) {
      govde.sections = bolumler.join(',');
      govde.sections_url = location.pathname;
    }
    return fetch(url, { method: 'POST', headers: BASLIK, body: JSON.stringify(govde) })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function sirayla(ops) {
    var ids = bolumIdleri();
    return ops.reduce(function (zincir, op, i) {
      return zincir.then(function () {
        return opUygula(op, i === ops.length - 1 ? ids : null);
      });
    }, Promise.resolve(null));
  }

  function parcaDegis(sel, kok, yeniDoc) {
    var e = kok.querySelector(sel), y = yeniDoc.querySelector(sel);
    if (e && y) { e.innerHTML = y.innerHTML; return true; }
    return false;
  }

  /* Paketli cevaptaki section HTML'ini temanin KENDI yeniden cizim
     yontemiyle yerlestirir (refreshQuickCart / refreshCart ne degistiriyorsa
     o): drawer'da satir listesi, baslik sayaci, ara toplam; sepet sayfasinda
     [js-cart-items] ve toplam sarmalayicisi. Kapsayici dugumler yerinde kalir,
     temanin delegasyonla bagli tiklama dinleyicileri calismaya devam eder.
     adet verilirse header sepet sayaci da guncellenir. */
  function ciz(bolumler, adet) {
    if (!bolumler) return false;
    var cizildi = false;
    var qc = document.querySelector('.quick-cart[data-section-id]');
    var qcHtml = qc && bolumler[qc.getAttribute('data-section-id')];
    if (qcHtml) {
      var d = new DOMParser().parseFromString(qcHtml, 'text/html');
      var eski = qc.querySelector('.quick-cart__items'), yeni = d.querySelector('.quick-cart__items');
      if (eski && yeni) {
        eski.innerHTML = yeni.innerHTML;
        parcaDegis('.quick-cart__heading', qc, d);
        parcaDegis('.quick-cart__footer-subtotal', qc, d);
        cizildi = true;
      } else {
        cizildi = parcaDegis('.quick-cart__container', qc, d);
      }
    }
    var mc = document.querySelector('[data-section-type="cart"][data-section-id]');
    var mcHtml = mc && bolumler[mc.getAttribute('data-section-id')];
    if (mcHtml) {
      var d2 = new DOMParser().parseFromString(mcHtml, 'text/html');
      var e2 = mc.querySelector('[js-cart-items]'), y2 = d2.querySelector('[js-cart-items]');
      if (e2 && y2) {
        e2.innerHTML = y2.innerHTML;
        var f2 = mc.querySelector('[js-cart-footer-subtotal-wrapper]'), g2 = d2.querySelector('[js-cart-footer-subtotal-wrapper]');
        if (f2 && g2) f2.outerHTML = g2.outerHTML;
        cizildi = true;
      } else {
        cizildi = parcaDegis('.cart__container', mc, d2) || cizildi;
      }
    }
    if (cizildi && typeof adet === 'number') {
      var say = document.querySelectorAll('[data-js-cart-count]');
      for (var i = 0; i < say.length; i++) if (say[i].textContent !== String(adet)) say[i].textContent = String(adet);
    }
    return cizildi;
  }

  /* Sepet DOM'unu temanin KENDI yoluyla yeniden cizdirir.
       Drawer: apps:product-added-to-cart -> tema quick-cart section'ini
         ?section_id ile sunucudan alir, satir listesini komple degistirir,
         header sayacini gunceller (Stiletto'nun resmi uygulama kancasi).
       Sepet sayfasi: main-cart yalnizca temanin ic "cart:updated" olayina
         tepki verir. Disaridan tek tetik: SEPETTE HALA VAR OLAN hediye disi
         bir satirin adet kutusuna change olayi -> tema ayni adedi yeniden
         yazar, ardindan bolumu ?section_id ile yeniden cizer.
     false donerse cagiran sayfayi yeniler. */
  function yenile(cart) {
    if (document.querySelector('.quick-cart')) {
      try { document.dispatchEvent(new CustomEvent('apps:product-added-to-cart')); } catch (e) {}
    }
    if (!sepetSayfasi()) return true;

    var keys = {};
    (cart.items || []).forEach(function (i) { keys[i.key] = i; });
    var nodes = document.querySelectorAll('.cart__form-item[data-key]');
    for (var i = 0; i < nodes.length; i++) {
      var it = keys[nodes[i].getAttribute('data-key')];
      if (!it || (it.properties && it.properties._hediye)) continue;
      var inp = nodes[i].querySelector('.quantity-input__input');
      if (inp) {
        inp.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
    }
    return false;
  }

  /* Guvenlik agi: temanin kendi yeniden cizimi bizimkinden SONRA gelirse DOM
     bayat kalabilir (sepette hediye var, DOM'da yok ya da tersi). Yalnizca
     hediye satirlari karsilastirilir; en fazla 1,5 sn'de bir yenilenir. */
  function tutarlilik(cart) {
    var nodes = document.querySelectorAll(ITEM_SEL);
    if (!nodes.length) return;
    var dom = {}, sepet = {};
    for (var i = 0; i < nodes.length; i++) dom[nodes[i].getAttribute('data-key')] = nodes[i];
    (cart.items || []).forEach(function (it) { if (it.properties && it.properties._hediye) sepet[it.key] = 1; });
    var uyumsuz = false;
    Object.keys(sepet).forEach(function (k) { if (!dom[k]) uyumsuz = true; });
    Object.keys(dom).forEach(function (k) {
      if (dom[k].classList.contains('pahb-satir') && !sepet[k]) uyumsuz = true;
    });
    if (uyumsuz && Date.now() - sonTutarlilik > 1500) {
      sonTutarlilik = Date.now();
      yenile(cart);
    }
  }

  /* ---------- bar ---------- */

  /* Parcali dogrusal: rozetler esit sutunlarda; dolgu her kademe rozetinin
     tam altinda o kademenin esigine denk gelir. (Para ile orantili yerlesim
     denendi, geri alindi - bkz. pa-hediye-bar.liquid basligi.) Ayni matematik
     snippets/pa-hediye-bar.liquid icinde sunucu tarafinda da var - biri
     degisirse digeri de degismeli. */
  function dolgu(uygun) {
    var n = KADEMELER.length;
    var adim = 100 / n;
    var oncekiEsik = 0, oncekiNokta = 0;
    for (var i = 0; i < n; i++) {
      var nokta = adim * (i + 0.5);
      var esik = KADEMELER[i].esik;
      if (uygun < esik) {
        var aralik = esik - oncekiEsik;
        var oran = aralik > 0 ? (uygun - oncekiEsik) / aralik : 0;
        return oncekiNokta + (nokta - oncekiNokta) * Math.max(0, Math.min(1, oran));
      }
      oncekiEsik = esik;
      oncekiNokta = nokta;
    }
    return 100;
  }

  function mesaj(uygun) {
    for (var i = 0; i < KADEMELER.length; i++) {
      var k = KADEMELER[i];
      if (uygun < k.esik) {
        return '<b>' + para(k.esik - uygun) + '</b> daha ekle, <b>' + esc(k.odul) + '</b> kazan';
      }
    }
    return CFG.tamMesaj || 'Tüm ödülleri kazandın';
  }

  function rozetHtml(k, uygun) {
    var acik = uygun >= k.esik;
    var gorsel = k.gorsel
      ? '<img src="' + esc(k.gorsel) + '" alt="" width="44" height="44"' +
        (k.gorselKonum ? ' style="object-position:' + esc(k.gorselKonum) + '"' : '') + '>'
      : (CFG.kargoIkon || '');
    return '<div class="pahb-t' + (acik ? ' on' : '') + '">' +
      '<span class="pahb-ic">' + gorsel + (acik ? '<i class="pahb-tick" aria-hidden="true"></i>' : '') + '</span>' +
      '<span class="pahb-tut">' + para(k.esik) + '</span>' +
      '<span class="pahb-ad">' + esc(k.odul) + '</span>' +
      '</div>';
  }

  function barlariBoya(cart) {
    var barlar = document.querySelectorAll('[data-pahb]');
    if (!barlar.length) return;
    var uygun = uygunTutar(cart);
    var imza = String(uygun);
    for (var i = 0; i < barlar.length; i++) {
      var b = barlar[i];
      if (b.getAttribute('data-pahb-imza') === imza) continue;
      b.setAttribute('data-pahb-imza', imza);
      var msg = b.querySelector('[data-pahb-msg]');
      var fill = b.querySelector('[data-pahb-fill]');
      var tiers = b.querySelector('[data-pahb-tiers]');
      if (msg) msg.innerHTML = mesaj(uygun);
      if (fill) fill.style.width = dolgu(uygun).toFixed(2) + '%';
      if (tiers) {
        tiers.innerHTML = KADEMELER.map(function (k) { return rozetHtml(k, uygun); }).join('');
      }
      b.classList.toggle('pahb-tam', uygun >= KADEMELER[KADEMELER.length - 1].esik);
    }
  }

  /* Sepet SAYFASINDA bar temanin duzeninde saga/asagiya, toplamlarin ustune
     dusuyor. Masaustunde sorun degil (sag kolon hep gorunur) ama telefonda
     urun listesinin ALTINDA kaliyor ve kimse gormuyor. Dar ekranda listenin
     basina bir KOPYASI konur, alttaki gizlenir.
     Neden kopya, neden tasima degil: tema her guncellemede urun listesinin
     (js-cart-items) innerHTML'ini yeniden yaziyor; tasinan dugum onunla
     birlikte silinirdi ve alt tarafta da bar kalmadigi icin ekranda hic bar
     gorunmezdi. Kopya silinince alttaki kaynak durdugu icin yeniden kopyalanir.
     barlariBoya() her [data-pahb] dugumunu boyadigi icin kopya da guncel kalir. */
  function barYeriniDuzelt() {
    if (window.innerWidth > 768) return;
    /* main-cart.liquid bari mobil icin listenin basina SUNUCUDA basiyor
       (.pahb-ust-mobil); o varsa kopyaya gerek yok - yerlesim kaymasi (CLS) da olmaz. */
    if (document.querySelector('.pahb-ust-mobil')) return;
    var kaynak = document.querySelector('.cart__footer [data-pahb]');
    var liste = document.querySelector('.cart__form-items');
    if (!kaynak || !liste) return;
    kaynak.classList.add('pahb-alt-gizli');
    for (var c = liste.firstElementChild; c; c = c.nextElementSibling) {
      if (c.hasAttribute('data-pahb')) return;
    }
    var kopya = kaynak.cloneNode(true);
    kopya.classList.remove('pahb-alt-gizli');
    liste.insertBefore(kopya, liste.firstChild);
  }

  /* ---------- hediye satirlarinin gorunumu (YEDEK) ----------
     Normalde sunucu basar (pa-hediye-satir.liquid). Burasi yalnizca eksik
     kalan parcalari tamamlar; var olana dokunmaz -> tekleme yok. */

  function secimHtml(k, secili) {
    var l = k.secenekler || [];
    if (l.length < 2) return '';
    var dugmeler = l.map(function (s) {
      var cls = 'pahb-sec' + (s.id === secili ? ' sel' : '') + (s.stok ? '' : ' ko');
      return '<button type="button" class="' + cls + '" data-pahb-sec="' + s.id + '" data-pahb-barem="' +
        esc(k.id) + '"' + (s.stok ? '' : ' disabled') + '>' + esc(s.ad) + '</button>';
    }).join('');
    return '<div class="pahb-secim"><span class="pahb-secim-baslik">' + esc(k.secimBaslik || 'Seç') +
      '</span><div class="pahb-secim-liste">' + dugmeler + '</div></div>';
  }

  /* Fonksiyon satiri sifirladiginda (final_line_price < original_line_price)
     fiyat alani "~~587,00~~ 0,00" olarak yazilir: ustu cizilen, urunun kendi
     satis fiyatidir (compare-at 734 degil). Sunucu ayni sonucu data-pahb-fiyat
     ile isaretleyip basar; isaret varsa dokunulmaz. */
  function fiyatiYaz(node, item) {
    if (!(item.final_line_price < item.original_line_price)) return;
    var sar = node.querySelector('.quick-cart__item-price-wrapper, .cart__form-item-price-wrapper');
    if (!sar || sar.getAttribute('data-pahb-fiyat') === String(item.final_line_price)) return;
    var cls = sar.classList.contains('quick-cart__item-price-wrapper') ? 'quick-cart__item-price' : 'cart__form-item-price';
    var iso = /TRY/.test(sar.textContent) ? ' TRY' : '';
    sar.innerHTML = '<s class="' + cls + '">' + para(item.original_price * item.quantity) + iso + '</s> ' +
      '<span class="' + cls + ' sale-price">' + para(item.final_line_price) + iso + '</span>';
    sar.setAttribute('data-pahb-fiyat', String(item.final_line_price));
  }

  function satirlariSusle(cart) {
    var byKey = {};
    (cart.items || []).forEach(function (i) { byKey[i.key] = i; });

    var nodes = document.querySelectorAll(ITEM_SEL);
    for (var n = 0; n < nodes.length; n++) {
      var node = nodes[n];
      var item = byKey[node.getAttribute('data-key')];
      if (!item || !item.properties || !item.properties._hediye) continue;

      var k = null;
      for (var q = 0; q < KADEMELER.length; q++) {
        if (KADEMELER[q].id === item.properties._hediye_barem) k = KADEMELER[q];
      }
      if (!k) continue;

      node.classList.add('pahb-satir');

      /* Sunucu basmissa (pahb-ssr) rozet/secici/arsiv zaten dogru; fiyat
         isareti de var. Yalnizca sunucu basamamis satirlar tamamlanir. */
      if (!node.classList.contains('pahb-ssr')) {
        var listeler = node.querySelectorAll('ul[class*="item-discounts"]');
        for (var u = 0; u < listeler.length; u++) {
          var lis = listeler[u].querySelectorAll('li');
          var gorunur = 0;
          for (var d = 0; d < lis.length; d++) {
            if ((lis[d].textContent || '').indexOf('Arşiv') !== -1) lis[d].style.display = 'none';
            else if (lis[d].style.display !== 'none') gorunur++;
          }
          listeler[u].style.display = gorunur ? '' : 'none';
        }
      }

      fiyatiYaz(node, item);

      var hedef = node.querySelector('.quick-cart__item-top') || node.querySelector('.cart__form-item-info') || node;

      if (!node.querySelector('.pahb-rozet')) {
        var rozet = document.createElement('span');
        rozet.className = 'pahb-rozet';
        rozet.setAttribute('data-pahb-barem-id', k.id);
        rozet.textContent = CFG.satirRozet || 'HEDİYE';
        hedef.insertBefore(rozet, hedef.firstChild);
      }

      var mevcutSecim = node.querySelector('.pahb-secim');
      var html = secimHtml(k, item.variant_id || item.id);
      if (html) {
        if (!mevcutSecim) {
          var sar = document.createElement('div');
          sar.innerHTML = html;
          hedef.appendChild(sar.firstChild);
        } else if (mevcutSecim.getAttribute('data-vid') !== String(item.variant_id || item.id)) {
          mevcutSecim.outerHTML = html;
        }
        var yeni = node.querySelector('.pahb-secim');
        if (yeni) yeni.setAttribute('data-vid', String(item.variant_id || item.id));
      }
    }
  }

  /* ---------- iyimser cizim ----------
     Sunucu her sepet degisikliginde indirim fonksiyonunu calistiriyor
     (change.js ~600 ms, add.js ~900 ms) ve hediye icin iki degisiklik zorunlu
     (musterininki + bizimki). Alt sinir ~1,5-2 sn. Bekleme hissini kaldirmak
     icin karar aninda (musterinin degisikligi sunucudan doner donmez):
       - eklenecek hediye, mevcut bir satir KLONLANARAK hemen listeye konur
         (ayni iskelet -> gercek satir gelince goze carpan degisim yok),
       - silinecek hediye satiri hemen gizlenir.
     Temanin kendi yeniden cizimi (bizimkinden once biter, bizim degisikligi
     icermez) DOM'u ezerse MutationObserver ayni karari SENKRON olarak tekrar
     uygular - callback boyamadan once kostugu icin ekranda geri gelme olmaz. */

  function iyimserSatir(sablon, k, sec, drawer) {
    var n = sablon.cloneNode(true);
    n.setAttribute('data-key', 'pa-iyimser-' + k.id);
    n.removeAttribute('data-id');
    n.className = (drawer ? 'quick-cart__item' : 'cart__form-item') + ' pahb-satir pahb-ssr pahb-iyimser';
    var img = n.querySelector('img');
    if (img) {
      if (sec.gorsel) { img.src = sec.gorsel; img.srcset = ''; img.removeAttribute('data-src'); img.removeAttribute('data-srcset'); }
      img.alt = '';
    }
    var baslik = n.querySelector(drawer ? '.quick-cart__item-title' : '.cart__form-item-title');
    if (baslik) { var a = baslik.querySelector('a') || baslik; a.textContent = k.odul; if (a.tagName === 'A') a.removeAttribute('href'); }
    var varyant = n.querySelector(drawer ? '.quick-cart__item-variant' : '.cart__form-item-variant');
    if (varyant) varyant.textContent = sec.ad;
    var fiyat = n.querySelector(drawer ? '.quick-cart__item-price-wrapper' : '.cart__form-item-price-wrapper');
    if (fiyat) fiyat.innerHTML = '<span class="pahb-iyimser-durum">Sepete ekleniyor…</span>';
    /* KRITIK (15 Eyl 2026 canli hata): klonda kalan name="updates[]" girdisi GIZLENSE
       BILE form submit edildiginde gonderilir. Shopify updates[] dizisini KONUMSAL
       uygular; fazladan girdi tum miktarlari kaydirir -> hediye ucretli olur, urun
       kaybolur. Klondan isimli tum form girdileri SILINIR. */
    var eskiler = n.querySelectorAll('ul[class*="item-discounts"], .pahb-rozet, .pahb-secim, [data-item-properties], [class*="inventory-warning"], [class*="item-error"], .quantity-input, [data-remove-item], input[name], select[name], textarea[name]');
    for (var i = 0; i < eskiler.length; i++) eskiler[i].parentNode.removeChild(eskiler[i]);
    var hedef = n.querySelector(drawer ? '.quick-cart__item-top' : '.cart__form-item-info') || n;
    var rozet = document.createElement('span');
    rozet.className = 'pahb-rozet';
    rozet.setAttribute('data-pahb-barem-id', k.id);
    rozet.textContent = CFG.satirRozet || 'HEDİYE';
    hedef.insertBefore(rozet, hedef.firstChild);
    var html = secimHtml(k, sec.id);
    if (html) { var sar = document.createElement('div'); sar.innerHTML = html; hedef.appendChild(sar.firstChild); }
    return n;
  }

  function iyimserUygula() {
    if (!iyimser) return;
    var i, j;
    if (iyimser.sil) {
      for (i = 0; i < iyimser.sil.length; i++) {
        var gizle = document.querySelectorAll('[data-key="' + iyimser.sil[i] + '"]');
        for (j = 0; j < gizle.length; j++) gizle[j].style.display = 'none';
      }
    }
    if (iyimser.ekle) {
      var listeler = [
        { kok: document.querySelector('.quick-cart .quick-cart__items'), sel: '.quick-cart__item[data-key]', drawer: true },
        { kok: document.querySelector('[js-cart-items]'), sel: '.cart__form-item[data-key]', drawer: false }
      ];
      for (i = 0; i < listeler.length; i++) {
        var L = listeler[i];
        if (!L.kok) continue;
        for (j = 0; j < iyimser.ekle.length; j++) {
          var e = iyimser.ekle[j];
          if (L.kok.querySelector('[data-key="pa-iyimser-' + e.k.id + '"]')) continue;
          /* BU KADEMENIN gercek (gorunur) satiri geldiyse yer tutucuya gerek yok.
             Baska kademenin satiri (sweatshirt varken sapka degisimi) sayilmaz;
             renk/beden degisiminde gizlenen eski satir da sayilmaz. */
          var gercek = L.kok.querySelectorAll('.pahb-satir:not(.pahb-iyimser) .pahb-rozet[data-pahb-barem-id="' + e.k.id + '"]'), gorunur = false;
          for (var g = 0; g < gercek.length; g++) {
            var sat = gercek[g].closest('[data-key]');
            if (sat && sat.style.display !== 'none') gorunur = true;
          }
          if (gorunur) continue;
          var sablon = null, adaylar = L.kok.querySelectorAll(L.sel);
          for (var q = 0; q < adaylar.length; q++) {
            if (!adaylar[q].classList.contains('pahb-satir') && adaylar[q].style.display !== 'none') { sablon = adaylar[q]; break; }
          }
          if (!sablon) continue;
          /* Sunucu hediye satirlarini SABIT sirada (kademe sirasi) en ustte basar.
             Yer tutucu da ayni yuvaya konur ki gercek satir geldiginde yer
             degistirme olmasin:
               - renk/beden degisimi: gizlenen eski satirin hemen onune,
               - yeni kademe: sonraki kademenin satirinin onune, o yoksa ilk
                 hediye-disi satirin onune. */
          var yuva = null;
          var eskiRozet = L.kok.querySelector('.pahb-satir:not(.pahb-iyimser) .pahb-rozet[data-pahb-barem-id="' + e.k.id + '"]');
          if (eskiRozet) yuva = eskiRozet.closest('[data-key]');
          if (!yuva) {
            var sonra = false;
            for (var ki = 0; ki < KADEMELER.length && !yuva; ki++) {
              if (KADEMELER[ki].id === e.k.id) { sonra = true; continue; }
              if (!sonra || KADEMELER[ki].tip !== 'hediye') continue;
              var r2 = L.kok.querySelector('.pahb-satir:not(.pahb-iyimser) .pahb-rozet[data-pahb-barem-id="' + KADEMELER[ki].id + '"]');
              if (r2) yuva = r2.closest('[data-key]');
            }
          }
          if (!yuva) yuva = sablon;
          yuva.parentNode.insertBefore(iyimserSatir(sablon, e.k, e.sec, L.drawer), yuva);
        }
      }
    }
    /* DIKKAT: textContent yazmak da bir DOM degisimidir; ayni degeri tekrar
       yazmak observer'i tetikleyip sonsuz donguye sokar. Yalnizca farkliysa yaz. */
    if (typeof iyimser.adet === 'number') {
      var say = document.querySelectorAll('[data-js-cart-count], .quick-cart__heading sup');
      var metin = String(iyimser.adet);
      for (i = 0; i < say.length; i++) if (say[i].textContent !== metin) say[i].textContent = metin;
    }
  }

  function iyimserBaslat(cart, ops) {
    var st = { ekle: [], sil: [], adet: cart.item_count || 0 };
    for (var i = 0; i < ops.length; i++) {
      var op = ops[i];
      if (op.tip === 'ekle') {
        var k = null, sec = null;
        for (var q = 0; q < KADEMELER.length; q++) if (KADEMELER[q].id === op.barem) k = KADEMELER[q];
        if (k) sec = secenekBul(k, op.vid);
        if (k && sec) { st.ekle.push({ k: k, sec: sec }); st.adet += 1; }
      } else if (op.tip === 'sil') {
        st.sil.push(op.key);
        var it = null;
        for (var w = 0; w < (cart.items || []).length; w++) if (cart.items[w].key === op.key) it = cart.items[w];
        st.adet -= it ? (it.quantity || 1) : 1;
      }
    }
    iyimser = st;
    iyimserUygula();
  }

  /* ---------- ana dongu ---------- */

  /* Eldeki sepetle uzlastir: is varsa yap, temaya yeniden cizdir. */
  function uzlastir(cart) {
    mesgul = true;
    var ops;
    try {
      ops = islemleriHesapla(cart);
      if (!ops.length) {
        barlariBoya(cart);
        barYeriniDuzelt();
        satirlariSusle(cart);
        tutarlilik(cart);
        mesgul = false;
        return Promise.resolve();
      }
      /* Hediye satirlari uygun tutara sayilmadigi icin bar, islem oncesi sepetle
         simdiden dogru boyanir; satir da iyimser olarak hemen cizilir. */
      barlariBoya(cart);
      iyimserBaslat(cart, ops);
    } catch (e) {
      /* Senkron bir hata mesgul bayragini asili birakmasin - yoksa motor
         sayfa yenilenene kadar susar. */
      mesgul = false;
      iyimser = null;
      return Promise.resolve();
    }
    var adetTahmin = iyimser ? iyimser.adet : cart.item_count;
    return sirayla(ops).then(function (son) {
      var sepet = sepetMi(son) ? son : null;
      mesgul = false;
      iyimser = null;
      var adet = sepet ? sepet.item_count : adetTahmin;
      if (ciz(son && son.sections, adet)) return;
      return (sepet ? Promise.resolve(sepet) : sepetAl()).then(function (yeni) {
        if (!yenile(yeni)) location.reload();
      });
    }).catch(function () { mesgul = false; iyimser = null; });
  }

  function calis() {
    if (mesgul) return;
    mesgul = true;
    sepetAl().then(function (cart) {
      mesgul = false;
      return uzlastir(cart);
    }).catch(function () { mesgul = false; });
  }

  /* Gecikmeli (sessizlik bekleyen) calisma: DOM degisiklikleri icin. Her yeni
     degisiklik sayaci sifirlar; sayfada surekli DOM basan baska scriptler
     (cart-smart-offer her ~1 sn /cart.js cekip yeniden basiyor) bunu uzun sure
     erteleyebilir. Bu yuzden temanin sepet cevabi geldiginde bu yol DEGIL,
     hemenCalis() kullanilir. */
  function planla(gecikme) {
    clearTimeout(zaman);
    zaman = setTimeout(calis, gecikme || 280);
  }

  /* Iptal edilemez yol: temanin /cart/add.js cevabi sepet olmadiginda
     (yalniz eklenen satir doner) sepeti hemen cekip uzlastir. */
  function hemenCalis() {
    if (mesgul) { setTimeout(hemenCalis, 60); return; }
    clearTimeout(zaman);
    calis();
  }

  /* Temanin cevabindaki sepetle beklemeden uzlastir. */
  function hizli(cart) {
    if (mesgul) { setTimeout(function () { hizli(cart); }, 60); return; }
    clearTimeout(zaman);
    uzlastir(cart);
  }

  /* ---------- temanin sepet cagrilarini yakala ---------- */
  var _fetch = window.fetch;
  window.fetch = function (input, init) {
    var p = _fetch.apply(this, arguments);
    try {
      var url = typeof input === 'string' ? input : ((input && input.url) || '');
      var bizim = !!(init && init.headers && (init.headers['X-PA-Hediye'] ||
        (typeof init.headers.get === 'function' && init.headers.get('X-PA-Hediye'))));
      if (!bizim && /\/cart\/(change|update|add|clear)(\.js)?(\?|$)/.test(url)) {
        p.then(function (r) {
          if (!r.ok) return;
          r.clone().json().then(function (c) {
            if (sepetMi(c)) hizli(c); else hemenCalis();
          }).catch(function () { hemenCalis(); });
        }).catch(function () {});
      }
    } catch (e) {}
    return p;
  };

  /* Secenek degistirme: eski satir silinir, yenisi ayni property'lerle eklenir,
     ardindan tema kendi yolundan yeniden cizer (eski gri satir DOM'dan gider). */
  document.addEventListener('click', function (ev) {
    if (!ev.target || !ev.target.closest) return;
    var btn = ev.target.closest('[data-pahb-sec]');
    if (!btn || btn.disabled) return;
    ev.preventDefault();

    var baremId = btn.getAttribute('data-pahb-barem');
    var vid = parseInt(btn.getAttribute('data-pahb-sec'), 10);
    var node = btn.closest('[data-key]');
    if (!node || !vid) return;

    var k = null;
    for (var i = 0; i < KADEMELER.length; i++) if (KADEMELER[i].id === baremId) k = KADEMELER[i];
    if (!k) return;

    hafizaYaz(baremId, vid);

    var eskiKey = node.getAttribute('data-key');
    var yeniSec = secenekBul(k, vid);
    mesgul = true;
    if (yeniSec) {
      iyimser = { sil: [eskiKey], ekle: [{ k: k, sec: yeniSec }] };
      iyimserUygula();
    } else {
      btn.closest('.pahb-secim').classList.add('pahb-bekle');
    }
    opUygula({ tip: 'sil', key: eskiKey })
      .then(function () {
        return opUygula({ tip: 'ekle', vid: vid, barem: baremId, esik: k.esik }, bolumIdleri());
      })
      .then(function (son) {
        mesgul = false;
        iyimser = null;
        if (ciz(son && son.sections, null)) { planla(400); return; }
        return sepetAl().then(function (yeni) {
          if (!yenile(yeni)) location.reload();
          planla(600);
        });
      })
      .catch(function () { mesgul = false; iyimser = null; planla(300); });
  });

  var mo = new MutationObserver(function (muts) {
    var dis = false;
    for (var i = 0; i < muts.length; i++) {
      var t = muts[i].target;
      if (t && t.closest && (t.closest('[data-pahb]') || t.closest('.pahb-iyimser') ||
          t.closest('[data-js-cart-count]') || t.closest('.quick-cart__heading') ||
          t.closest('[class^="cso-"], [class*=" cso-"]'))) continue;
      dis = true;
    }
    if (!dis) return;
    /* Tema DOM'u ezdiyse iyimser karari boyamadan once yeniden uygula. */
    iyimserUygula();
    planla();
  });
  if (document.body) mo.observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { planla(60); });
  } else {
    planla(60);
  }
})();
